import * as React from "react";
import {APIClient} from "../../../utils/APIClient";
import FacebookLogin from '@greatsumini/react-facebook-login';
import {facebookAppId} from "../../../settings/settings";
import {API_URL} from "../../../settings/local_settings";
import {FaIcon} from "../../FaIcon";
import { FACEBOOK_CHANNEL } from '../../channels/channels';
import { withTranslation } from 'react-i18next';


export class FacebookLinkComponentClass extends React.Component {
    constructor(props) {
        super(props);

        this.deleteAgencyConnection = this.deleteAgencyConnection.bind(this);
        this.responseFacebook = this.responseFacebook.bind(this);
    }

    responseFacebook(response) {
        const { t } = this.props;
        const credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        const payload = {...response, credential_label: credential_label};
        new APIClient(API_URL + 'store_facebook_access_token/').call('POST', payload)
            .then((data) => {
                if (data.status === 'OK') {
                    alert(t('facebook_link.account_linked_successfully'));
                    window.location = '/agency/conections?just_connected='+FACEBOOK_CHANNEL;
                } else {
                    alert(data.error_message)
                }
            })
            .catch((error) => {
                alert(error);
            });
    }

    deleteAgencyConnection() {
        new APIClient(API_URL + 'agency/facebook-connection/delete/').call('POST')
            .then((data) => {
                this.props.onConnectionDeleted()
            }).catch((error) => {
            alert(error)
        })
    }

    render() {
        const { t } = this.props;
        if (this.props.hasConnection === false) {
            return (
                <FacebookLogin
                    appId={facebookAppId}
                    scope="ads_management"
                    onSuccess={this.responseFacebook}
                    className="btn facebook"
                >
                    <FaIcon prefix="fab" iconName="facebook-f"/> {t('facebook_link.connect_facebook_ads')}
                </FacebookLogin>
            )
        } else {
            return (
                <button className="btn facebook" onClick={this.deleteAgencyConnection}>
                    <FaIcon prefix="fab" iconName="facebook-f"/>{t('facebook_link.disconnect_from_facebook_ads')}
                </button>
            )
        }
    }
}

export const FacebookLinkComponent = withTranslation()(FacebookLinkComponentClass);
export default FacebookLinkComponent;
